"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HtmlRangeInput = void 0;
require("./HtmlRangeInput.scss");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 
 * 
 <div class="slidecontainer">
  <input type="range" min="1" max="100" value="50" class="slider" id="myRange">
  <p>Value: <span id="demo"></span></p>
</div>
 */
var HtmlRangeInput = exports.HtmlRangeInput = /*#__PURE__*/_createClass(function HtmlRangeInput(parent, min, max, value, values, oninput) {
  var _this = this;
  _classCallCheck(this, HtmlRangeInput);
  _defineProperty(this, "_node", void 0);
  _defineProperty(this, "_valueNode", void 0);
  _defineProperty(this, "_headerNode", void 0);
  _defineProperty(this, "_input", void 0);
  _defineProperty(this, "disable", function () {
    _this._input.setAttribute("disabled", "true");
  });
  _defineProperty(this, "enable", function () {
    _this._input.removeAttribute("disabled");
  });
  this._node = document.createElement("div");
  this._node.className = "slidecontainer rangeinput";
  var w = document.createElement("div");
  w.className = "wrap";
  this._headerNode = document.createElement("div");
  this._headerNode.className = "header";
  this._valueNode = document.createElement("div");
  this._valueNode.className = "value";
  w.appendChild(this._headerNode);
  w.appendChild(this._valueNode);
  this._node.appendChild(w);
  this._input = document.createElement("input");
  this._input.setAttribute("type", "range");
  this._input.setAttribute("min", min);
  this._input.setAttribute("max", max);
  this._input.setAttribute("value", value);
  this._input.className = "slider";
  this._node.appendChild(this._input);
  parent.appendChild(this._node);
  this._input.oninput = function () {
    oninput(values ? values[_this._input.value] : _this._input.value);
  };
});
//# sourceMappingURL=HtmlRangeInput.js.map